import { render, staticRenderFns } from "./PaisList.vue?vue&type=template&id=25bf6346&scoped=true&"
import script from "./PaisList.vue?vue&type=script&lang=js&"
export * from "./PaisList.vue?vue&type=script&lang=js&"
import style0 from "./PaisList.vue?vue&type=style&index=0&id=25bf6346&lang=scss&scoped=true&"
import style1 from "./PaisList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf6346",
  null
  
)

export default component.exports